/* 
* @Author: zysQd
* @Date: 2021-04-25 11:06:38
 * @Last Modified by: zysQd
 * @Last Modified time: 2022-08-16 10:23:50
*/
import axios from '@/utils/axios'

export const getTechService = (payload) => {
  return axios.get('/tech_service', {
    params: payload
  })
}

export const createTechService = (data) => {
    return axios.post(`/tech_service`, data)
}

export const updateTechService = (id, data) => {
    return axios.put(`/tech_service/${id}`, data)
}

export const assignTechPerson = (id, data) => {
    return axios.put(`/tech_service/assign_tech_person/${id}`, data)
}

export const getTechServiceById = (id, data) => {
  return axios.get(`/tech_service/${id}`, data)
}

export const techServiceVerify = (id, data) => {
  return axios.put(`/tech_service/verify/${id}`, data)
}

export const getTechServiceStat = (payload) => {
  return axios.get(`/tech_service_stat`, {
    params: payload
  })
}
